import { CancelCounterStart, CondaPlatformSettings, PaymentQRCodeType } from '../typings'
import Cookies from 'js-cookie'

export function getPlatformSettings(): CondaPlatformSettings {
    return window.platformSettings
}

export function getLockableNaturalProfileAttributes(): Array<string> {
    return getPlatformSettings()?.lockable_natural_profile_attributes
}

export function getLockableNaturalProfileRelations(): Array<string> {
    return getPlatformSettings()?.lockable_natural_profile_relations
}

export function getLockableLegalProfileAttributes(): Array<string> {
    return getPlatformSettings()?.lockable_legal_profile_attributes
}

export function getLockableLegalProfileRelations(): Array<string> {
    return getPlatformSettings()?.lockable_legal_profile_relations
}

export function getTermsUrl(): string {
    return getPlatformSettings()?.terms_url
}

export function getPrivacyUrl(): string {
    return getPlatformSettings()?.privacy_url
}

export function getExternalSecurityLink(): string {
    return getPlatformSettings()?.external_security_link
}

export function getAdminEmail(): string {
    return getPlatformSettings()?.admin_email
}

export function getPaymentQrCodeType(): PaymentQRCodeType {
    return getPlatformSettings()?.payment_qr_code_type
}

export function getPlatformName(): string {
    return getPlatformSettings()?.platform_name
}

export function getCurrency(): string {
    return getPlatformSettings()?.currency
}

export function isCouponCodeEnabled(): boolean {
    return window.condaIsCouponCodeEnabled
}

export function getSelfDisclosureFormUrl(): string {
    const language = Cookies.get('pll_language')
    const urls = getPlatformSettings()?.self_disclosure_form_url
    const neededUrl = urls?.find((url) => url.language === language)
    if (neededUrl) {
        return neededUrl.url
    }
    return urls?.[0]?.url ?? ''
}

export function isCertificateEnabled(): boolean {
    return getPlatformSettings()?.certificate
}

export function isCancelOrderButtonEnabled(): boolean {
    return getPlatformSettings()?.cancel_order_button_enabled ?? false
}

export function hasActiveCancelPolicy(): boolean {
    const s = getPlatformSettings()
    return s?.cancel_order_button_enabled === true && (s?.cancel_period_days ?? 0) > 0
}

export function isAcceptedOrderCancellable(): boolean {
    return getPlatformSettings()?.cancel_counter_start === CancelCounterStart.ACCEPTED_AT
}

export function computeCancelDeadline(order: {
    created_at: string
    paid_date: string | null
    investment_acceptance_date: string | null
}): Date | null {
    const settings = getPlatformSettings()
    if (!settings?.cancel_period_days) return null
    const field = settings.cancel_counter_start
    let start: string | null = null
    if (field === CancelCounterStart.CREATED_AT) start = order.created_at
    else if (field === CancelCounterStart.PAID_AT) start = order.paid_date
    else if (field === CancelCounterStart.ACCEPTED_AT) start = order.investment_acceptance_date
    if (!start) return null
    const d = new Date(start)
    d.setDate(d.getDate() + settings.cancel_period_days)
    return d
}
